/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_AfternoonInputs */

const en_eta_window_afternoon = /** @type {(inputs: Eta_Window_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13:00 – 18:00`)
};

const ja_eta_window_afternoon = /** @type {(inputs: Eta_Window_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13:00 – 18:00`)
};

const fr_eta_window_afternoon = /** @type {(inputs: Eta_Window_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13h00 – 18h00`)
};

const de_eta_window_afternoon = /** @type {(inputs: Eta_Window_AfternoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13:00 – 18:00`)
};

/**
* | output |
* | --- |
* | "13:00 – 18:00" |
*
* @param {Eta_Window_AfternoonInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_afternoon = /** @type {((inputs?: Eta_Window_AfternoonInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_AfternoonInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_afternoon(inputs)
	if (locale === "ja") return ja_eta_window_afternoon(inputs)
	if (locale === "fr") return fr_eta_window_afternoon(inputs)
	return de_eta_window_afternoon(inputs)
});